export function Lightbulb() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="65"
      viewBox="0 0 46 65"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.4898 38.0009C47.9832 29.5074 47.9832 15.7367 39.4898 7.24318C30.5822 -1.66439 16.1402 -1.66439 7.23258 7.24318C6.98864 7.48712 6.75055 7.73682 6.51849 7.99208C-1.5614 16.88 -0.906394 30.6351 7.98148 38.7149L11.9763 42.3466V49.731H34.7461V42.3466L38.7409 38.7149C38.9961 38.4829 39.2458 38.2448 39.4898 38.0009ZM25.4829 10.0102C25.4829 8.58721 24.3294 7.43362 22.9063 7.43362C14.5263 7.43362 7.73301 14.227 7.73301 22.607V23.1795L7.73581 23.3008C7.79915 24.6675 8.92725 25.7561 10.3096 25.7561C11.7326 25.7561 12.8862 24.6026 12.8862 23.1795V22.607L12.8879 22.4187C12.9883 16.9716 17.4353 12.5868 22.9063 12.5868C24.3294 12.5868 25.4829 11.4332 25.4829 10.0102Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9756 54.8838V56.8794C11.9756 61.1224 15.4152 64.5621 19.6582 64.5621H27.0627C31.3057 64.5621 34.7454 61.1224 34.7454 56.8794V54.8838L34.7453 54.8838H11.9756Z"
        fill="currentColor"
      />
    </svg>
  );
}
